import { useRef, useState, useEffect } from "react";
import { createApolloClient } from "@/apollo/client";
import { GET_WEB_PAGE } from "@/apollo/queries/webPage";
import MetaTags from "@/components/MetaTags/index";
import { useWebPageQuery } from "@/hooks";
import styles from "@/styles/WebPage.module.scss";
import { defaultMetatags } from "@/lib/constants";
import config from "@/lib/config";

function generateMetaTags(tags, path) {
  const defaultTags = defaultMetatags["vod"];
  const title = tags?.title || defaultTags.title;
  const keywords = tags?.keywords || defaultTags.keywords;
  const description = tags?.description || defaultTags.description;
  const metatags = {
    title,
    keywords,
    description,
    og: {
      type: "article",
      title,
      description,
      url: `${config.host["vod"]}${path}`,
    },
    twitter: {
      title,
      description,
    },
  };
  if (tags?.robots) {
    metatags.robots = tags?.robots;
  }
  if (tags?.canonicalUrl) {
    metatags.canonicalUrl = tags?.canonicalUrl;
  }
  return metatags;
}

function WebPage({ path }) {
  const webPage = useRef();
  const [html, setHtml] = useState("");
  const { loading, data } = useWebPageQuery({
    variables: { path },
    fetchPolicy: "cache-first",
  });
  const { content, style, script } = data?.webPage || {};

  useEffect(() => {
    if (webPage.current) {
      const _html = `<style>${style}</style>${content}`;
      setHtml(_html);
    }
  }, [content, style]);

  useEffect(() => {
    if (webPage.current && html) {
      const scriptEl = document.createElement("script");
      scriptEl.type = "text/javascript";
      scriptEl.async = true;
      scriptEl.innerHTML = `
      (function () {
        try {
          ${script}
        } catch (e) {
          console.error(e);
        }
      }());`;

      webPage.current.appendChild(scriptEl);
    }
  }, [html]);

  if (loading) return null;
  const metatags = generateMetaTags(data?.webPage?.metatags, path);

  return (
    <>
      <MetaTags {...metatags} />
      <div
        ref={webPage}
        className={styles.webpage}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </>
  );
}

export default WebPage;

export async function getWebPage(req, res, path, apolloClient) {
  if (!apolloClient) {
    apolloClient = createApolloClient(req, res);
  }
  const { data } = await apolloClient.query({
    query: GET_WEB_PAGE,
    variables: { path },
    fetchPolicy: "network-only",
  });
  if (data.webPage.id) {
    const metatags = generateMetaTags(data?.webPage?.metatags, path);
    return [apolloClient.cache.extract(), metatags];
  } else {
    return [];
  }
}
